export interface HubSupportTicketStatusMetaRow {
  status: string;
  description: string;
  sort_order: number;
  may_close: boolean;
}

export function hubSupportTicketStatusMayClose(meta: HubSupportTicketStatusMetaRow[], status: string): boolean {
  return meta.find((row) => row.status === status)?.may_close ?? false;
}

export function hubSupportTicketAllowsPendingFeedback(input: {
  status: string;
  closed: boolean;
}): boolean {
  if (input.closed) {
    return false;
  }
  return input.status !== "resolved" && input.status !== "declined";
}

export function formatHubSupportTicketStatusLabel(status: string): string {
  return status.replace(/_/g, " ");
}
